import type { Buffer } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";

const NO_OP_RANGE = (cursor: Cursor): Range => ({ start: cursor, end: cursor, kind: "exclusive" });

/** `f{char}`: 同じ行内で次のcharへ移動する（inclusive）。 */
export function findCharForward(
  buffer: Buffer,
  cursor: Cursor,
  count: number | null,
  char?: string,
): Range {
  if (!char) {
    return NO_OP_RANGE(cursor);
  }
  const times = Math.max(count ?? 1, 1);
  const line = buffer.lines[cursor.line] ?? "";
  let col = cursor.col;
  for (let i = 0; i < times; i += 1) {
    const idx = line.indexOf(char, col + 1);
    if (idx === -1) {
      return NO_OP_RANGE(cursor);
    }
    col = idx;
  }
  return { start: cursor, end: { line: cursor.line, col }, kind: "inclusive" };
}

/** `t{char}`: 同じ行内で次のcharの直前まで移動する（inclusive）。 */
export function tillCharForward(
  buffer: Buffer,
  cursor: Cursor,
  count: number | null,
  char?: string,
): Range {
  if (!char) {
    return NO_OP_RANGE(cursor);
  }
  const times = Math.max(count ?? 1, 1);
  const line = buffer.lines[cursor.line] ?? "";
  let searchFrom = cursor.col + 1;
  let targetCol = cursor.col;
  for (let i = 0; i < times; i += 1) {
    const idx = line.indexOf(char, searchFrom);
    if (idx === -1) {
      return NO_OP_RANGE(cursor);
    }
    targetCol = idx - 1;
    searchFrom = idx + 1;
  }
  return {
    start: cursor,
    end: { line: cursor.line, col: Math.max(targetCol, cursor.col) },
    kind: "inclusive",
  };
}

/** `F{char}`: 同じ行内で前のcharへ移動する（`,`によるfの逆再生用。exclusive）。 */
export function findCharBackward(
  buffer: Buffer,
  cursor: Cursor,
  count: number | null,
  char?: string,
): Range {
  if (!char) {
    return NO_OP_RANGE(cursor);
  }
  const times = Math.max(count ?? 1, 1);
  const line = buffer.lines[cursor.line] ?? "";
  let col = cursor.col;
  for (let i = 0; i < times; i += 1) {
    const idx = line.lastIndexOf(char, col - 1);
    if (idx === -1) {
      return NO_OP_RANGE(cursor);
    }
    col = idx;
  }
  return { start: cursor, end: { line: cursor.line, col }, kind: "exclusive" };
}

/** `T{char}`: 同じ行内で前のcharの直後まで移動する（`,`によるtの逆再生用。exclusive）。 */
export function tillCharBackward(
  buffer: Buffer,
  cursor: Cursor,
  count: number | null,
  char?: string,
): Range {
  if (!char) {
    return NO_OP_RANGE(cursor);
  }
  const times = Math.max(count ?? 1, 1);
  const line = buffer.lines[cursor.line] ?? "";
  let searchFrom = cursor.col - 1;
  let targetCol = cursor.col;
  for (let i = 0; i < times; i += 1) {
    const idx = line.lastIndexOf(char, searchFrom);
    if (idx === -1) {
      return NO_OP_RANGE(cursor);
    }
    targetCol = idx + 1;
    searchFrom = idx - 1;
  }
  return {
    start: cursor,
    end: { line: cursor.line, col: Math.min(targetCol, cursor.col) },
    kind: "exclusive",
  };
}
